<template>
  <div>
    <div class="box news-box">
      <div class="sub-nav">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>监督管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="new-wrapper">
        <div class="left-box fl">
          <div class="left-box-title">
            <img src="../../assets/images/notice-icon.png" style="top: 14px" alt />
            监督管理
            <img src="../../assets/images/right.png" alt />
          </div>
          <div class="left-box-content">
              <img src="../../assets/images/supervision.png" alt="">
          </div>
        </div>
        <div class="right-box fr">
          <ul>
            <li  @click="handelTurnDetail(item)" class="normal" v-for="(item,index) in tableData" :key="index">
              <div>
                <span class="fl" :title="item.title">{{item.title}}</span>
                <span class="fr">{{item.publishTime | dateFormat}}</span>
              </div>
              <div class="clear"></div>
            </li>
          </ul>
          <div class="page">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page.current"
              :page-sizes="[10, 20, 50, 100,500]"
              :page-size="page.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="page.total"
              background
            ></el-pagination>
          </div>
        </div>
      </div>
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
import { getSupervisionPage } from "../../api/index";
export default {
  name: "",
  data() {
    return {
      query: {
        current: 1,
        size: 10,
        title: ""
      },
      fullHeight: document.documentElement.clientHeight,
      page: {
        total: 0
      },
      tableData: []
    };
  },
  created() {
    this.getData();
  },
  filters: {
			//将时间戳过滤为正常日期格式
			dateFormat: function (data) {
        if(!data){
          return;
        }
			  var date = new Date(data.replace(/-/g,"/")).Format("yyyy-MM-dd");
			  return date;
			}
	},
  methods: {
    getData() {
      getSupervisionPage(this.query).then(res => {
        this.tableData = res.data.records;
        this.page.total = res.data.total || 0;
      });
    },
    handleSizeChange(val) {
      this.$set(this.query, "size", val);
      this.getData();
    },
    handleCurrentChange(val) {
      this.$set(this.query, "current", val);
      this.getData();
    },
    handelTurnDetail(row) {
      this.$router.push({
        path: "/supervisionDetail/"+row.id
      });
    }
  }
};
</script>

<style lang="" >

</style>


// WEBPACK FOOTER //
// src/views/supervision/index.vue